import gql from 'graphql-tag'

export const chargerApiKeyDelete = gql`
  mutation chargerApiKeyDelete {
    chargerApiKeyDelete(input: {}) {
      success
    }
  }
`
